import { ButtonHTMLAttributes, forwardRef } from 'react'
import { ImageCircle, PersonCircleIcon, cn } from '$components'
import { User } from '$api-client/types.gen'
import {
  personSelectFilterIconStyling,
  personSelectFilterTextStyling,
  personSelectFilterTriggerStyling,
  PersonSelectFilterTriggerStyling,
} from './styling'

const MAX_ICON_DISPLAY = 4

export type PersonSelectTriggerProps = {
  selectedPeople: User[]
  size?: NonNullable<PersonSelectFilterTriggerStyling>['size']
} & ButtonHTMLAttributes<HTMLButtonElement>

export const PersonSelectTrigger = forwardRef<HTMLButtonElement, PersonSelectTriggerProps>(
  function PersonSelectTrigger(
    {
      selectedPeople,
      size = 'md',
      className,
      ...props
    },
    ref,
  ) {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(personSelectFilterTriggerStyling({ size }), className)}
        {...props}
      >
        {selectedPeople.length === 0 && (
          <span className={cn(personSelectFilterIconStyling({ size }), 'text-fg-subtle')}>
            <PersonCircleIcon className="size-4" />
          </span>
        )}

        <div className={cn(personSelectFilterTextStyling({ size }))}>
          <div className="flex">
            {selectedPeople.slice(0, MAX_ICON_DISPLAY).map((person, key) => (
              <div
                key={key}
                className={cn({
                  '-ml-stack-dense': key !== 0,
                })}
              >
                <ImageCircle
                  size={size}
                  image={person.image}
                />
              </div>
            ))}
          </div>

          <div>
            {selectedPeople.length === 1 && (
              <span className="block max-w-full sm:max-w-24 text-nowrap line-clamp-1 text-ellipsis">
                {selectedPeople[0].first_name + ' ' + selectedPeople[0].last_name}
              </span>
            )}

            {selectedPeople.length === 0 && 'All'}

            {selectedPeople.length > MAX_ICON_DISPLAY && (
              <span>
                + {selectedPeople.length - MAX_ICON_DISPLAY}
              </span>
            )}
          </div>
        </div>
      </button>
    )
  },
)
